import i18n from '@/plugins/i18n';

const applicationGraphs = () => ({
  barCharts: [
    {
      width: '100%',
      title: i18n.global.t('log.histogram'),
      header: {
        title: i18n.global.t('log.histogram'),
        titleIcon: '',
        content: [],
        hideCenterMiscContent: false,
        displayCustomButton: false,
        customButtonProp: {
          title: '',
        },
        hideCustomToolbarButtons: true,
      },
      chartColor: ['#e59ae2'],
      height: '25em',
      entityType: 'Endpoint',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'log_count',
      queryMetricType: 'readCustomMetricsValues',

      chartType: 'ApexChartBar',
      // unit: 'CPM - calls per minute',
      axisLabels: {
        x: '',
        y: '',
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'CPM',
      },
    },
  ],
});
export default applicationGraphs;
